'use client';

import { colors } from '../Colors/index.js';

var sizes = {
    medium: {
        paddingLeft: '8px',
        paddingRight: '8px',
        height: '34px'
    },
    small: {
        paddingLeft: '',
        paddingRight: '',
        height: ''
    }
};
var neutral = {
    outline: {
        border: colors.grey[80],
        background: '#fff',
        text: colors.grey[20]
    },
    filled: {
        border: colors.neutral[95],
        background: colors.neutral[95],
        text: colors.grey[20]
    }
};
var themes = { neutral: neutral };

export { themes as default, sizes };
//# sourceMappingURL=themes.js.map
